import { Route } from 'src/routes/Route'

export const DashboardSettingsRoute = Route({ path: '/settings' })
export type DashboardSettingsRoute = Route<typeof DashboardSettingsRoute>
